/* loaded by smart-asset */
export default require("./assets/barcode.i.svg")